module.exports = __webpack_public_path__ + "6546fb6b0f70ebffa69c7bb0b708eadd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/harp-s.png
// module id = 1901
// module chunks = 0